import DiamondsFour from '@/components/Icons/DiamondsFour';
import React, { FC } from 'react';

import s from './Linked.module.scss';

const Linked: FC<{
  number: number;
  onClick?: () => void;
}> = ({ number, onClick }) => (
  <div
    className={s.label}
    onClick={onClick}
    style={{
      cursor: onClick ? 'pointer' : 'default',
    }}
  >
    <div className={s.labelBg} />
    <DiamondsFour size={12} />
    Linked to {number} other fields
  </div>
);

export default Linked;
